import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toastr from 'toastr';
import {
    Card,
    CardBody,
    Col,
    Row,
    Modal,
    ModalHeader,
    Button,
    Popover,
    Spinner,
    PopoverBody,
    UncontrolledTooltip
} from "reactstrap";
import CardItem from "components/PurpleTheme/CardItem";
import Loader from "../../components/Loader/Loader";
import delpoyAlertsLottie from '../../assets/images/deploy_alerts_lottie.json';
import { useDispatch, useSelector } from "react-redux";
import {
    getDatadogApiEndpointsByApm as onGetDatadogApiEndpointsByApm,
    postDatadogRegisterEndpoint as onPostRegisterAPIEndpoint,
    getNotificationChannels as onGetNotificationChannels
}
    from '../../store/actions'
import {getDatadogName, getStateSpecificDatadogLogo} from "../../helpers/component_helpers";
import { getStateSpecificNRLogo as getNRLogo } from "../../helpers/component_helpers";
import DatadogApiEndpointsTab from "./DatadogApiEndpointsTab";
import { showNotification } from "components/Common/notification";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const DatadogApiEndpoints = (props) => {

    let urlParams = new URLSearchParams(window.location.search);
    let service_monitored_resource_id = urlParams.get('service_monitored_resource_id');

    document.title = "DatadogApiEndpoints | Temperstack";
    const params = useParams();
    const dispatch = useDispatch();

    const { api_endpoints_by_apm } = useSelector(state => ({
        api_endpoints_by_apm: state.Datadog.api_endpoints_by_apm || [],
    }));


    const [hoveredResource, setHoveredResource] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [selectedResourceId, setSelectedResourceId] = useState(null);
    const [isLoading2, setIsLoading2] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const itemsPerPage = 40;
    const [filteredResources, setFilteredResources] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isDateOpen, setIsDateOpen] = useState(false);
    const [primaryNotifChannel, setPrimaryNotifChannel] = useState(null);
    const toggle = () => setIsOpen(!isOpen);
    const toggleDates = () => setIsDateOpen(!isDateOpen);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const total_resources = filteredResources?.count || 0;
    const resourceCount = filteredResources && filteredResources.monitored_resources ? filteredResources.monitored_resources.length : 0;;
    useEffect(() => {
        setFilteredResources(api_endpoints_by_apm);
        setIsLoading(false);
    }, [api_endpoints_by_apm]);

    let pageFilters = {}
    useEffect(() => {
        let resourceId = params.resourceId
        pageFilters['apm_monitored_resource_id'] = service_monitored_resource_id
        dispatch(onGetDatadogApiEndpointsByApm(pageFilters));
    }, [onGetDatadogApiEndpointsByApm]);

    useEffect(() => {
        dispatch(onGetNotificationChannels());
    }, [onGetNotificationChannels])

    const { notification_channels } = useSelector(state => ({
        notification_channels: state.Dashboard.notification_channels || [],
    }));

    useEffect(() => {
        if (notification_channels && notification_channels.length > 0) {
            // Find the notification channel with is_primary set to true
            let primaryChannel = notification_channels.find(channel => channel.is_primary === true);
            setPrimaryNotifChannel(primaryChannel.name);
        }
    }, [notification_channels]);

    const startLoading2 = () => {
        setIsLoading2(true);

        setTimeout(() => {
            setIsLoading2(false);
        }, 5000);
    };

    const headers = [
        { label: "Resource Name", width: 2, marginBottom: 2, textCenter: true },
        { label: "Type", width: 2, marginBottom: 2, textCenter: true },
        { label: "Cloud ID", width: 2, marginBottom: 2, textCenter: true },
        { label: "Parent Resource Type", width: 2, marginBottom: 2, textCenter: true },
        { label: "Method", width: 2, marginBottom: 2, textCenter: true },
        { label: "Actions", width: 2, marginBottom: 2, textCenter: true },
    ];

    const handleDeployRegisterAPIEndpoint = (resourceId) => {
        setSelectedResourceId(resourceId);
        setShowConfirmationModal(true);
    }

    const confirmRegisterAPIEndpoint = () => {
        setShowConfirmationModal(false);
        var payload = {
            'monitored_resource_id': selectedResourceId
        }
        // @TOOD: Implement this action
        dispatch(onPostRegisterAPIEndpoint(payload));
    }

    const handleMouseEnter = (resourceId) => {
        setHoveredResource(resourceId);
    };

    const handleMouseLeave = () => {
        setHoveredResource(null);
    };

    const copyToClipboard = (textToCopy) => {

        if (navigator.clipboard) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => toastr.success("Copied!"))
                .catch(err => console.error('Could not copy text: ', err));
        } else {
            const textarea = document.createElement('textarea');
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                toastr.success("Copied!");
            } catch (err) {
                console.error('Could not copy text: ', err);
            }
            document.body.removeChild(textarea);
        }
    };

    const handlePageClick = (pageNumber) => {
        setIsLoading(true);

        if (pageNumber < 1) {
            setIsLoading(false);
            return;
        }

        if (selectedPage < pageNumber && filteredResources.length < itemsPerPage) {
            setIsLoading(false);
            return;
        }

        setSelectedPage(pageNumber);

        const formattedStartDate = startDate ? formatDate(startDate) : '';
        const formattedEndDate = endDate ? formatDate(endDate) : '';

        pageFilters['apm_monitored_resource_id'] = service_monitored_resource_id
        pageFilters['page'] = pageNumber;
        pageFilters['limit'] = itemsPerPage;
        pageFilters['search_item'] = search;
        pageFilters['start_date'] = formattedStartDate;
        pageFilters['end_date'] = formattedEndDate;
        dispatch(onGetDatadogApiEndpointsByApm(pageFilters));
        setSelectedPage(pageNumber);
    };

    function formatDate(dates) {
        const date = new Date(dates);
        const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
        return utcDate.toUTCString();
    }

    function formatResourceMetadata(data) {
        if (data === null) {
            return ""
        }
        // Load the json data
        const json_data = JSON.parse(data);
        if ("method" in json_data) {
            return json_data["method"];
        } else {
            // If the key does not exist, return an empty string
            return "";
        }
    }

    const handleStartDateChange = (event) => {
        const dateValue = event.target.value;
        setStartDate(dateValue ? new Date(dateValue) : null);
    };

    const handleEndDateChange = (event) => {
        const dateValue = event.target.value;
        const newEndDate = dateValue ? new Date(dateValue) : null;
        if (startDate && newEndDate && newEndDate < startDate) {
            showNotification("error", "End date cannot be before the start date")
            return;
        }
        setEndDate(newEndDate);
    };

    const handlePredefinedDateChange = (days) => {
        const today = new Date();
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - days);

        setStartDate(startDate);
        setEndDate(today);
    };

    return (
        <React.Fragment>
            <Col lg="8">
                <Breadcrumbs
                    title={"Datadog Api Endpoints"}
                    breadcrumbItem={"Api Endpoints of ".concat(filteredResources && filteredResources.monitored_resources && filteredResources.monitored_resources.length > 0 && filteredResources.monitored_resources[0].parent_resource.name)}
                />
            </Col>
            <Col lg="4">
            </Col>
            <div className="table-responsive table-purple">
                <DatadogApiEndpointsTab
                    selectedPage={selectedPage}
                    total_resources={total_resources}
                    itemsPerPage={itemsPerPage}
                    handlePageClick={handlePageClick}
                    isOpen={isOpen}
                    toggle={toggle}
                    setSearch={setSearch}
                    startDate={startDate}
                    endDate={endDate}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    toggleDates={toggleDates}
                    isDateOpen={isDateOpen}
                    handlePredefinedDateChange={handlePredefinedDateChange}
                />
            </div>
            <div className="header">
                <div className="resources-header-card">
                    <Row className="align-items-center padding-t-10">
                        {headers.map((header, index) => (
                            <Col md={header.width} key={index}>
                                <div className={`mb-${header.marginBottom} ${header.textCenter && "text-center"}`}>
                                    {header.label}
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
            <div>
                <div className="scrollable-container">
                    {isLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Spinner
                                color="primary"
                                style={{
                                    height: '3rem',
                                    width: '3rem'
                                }}
                            >
                                Loading...
                            </Spinner>
                        </div>
                    ) : filteredResources.length === 0 ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <h2 className="resource-name-truncate">
                                {isLoading ? "Loading resources..." : "No matching resources found."}
                            </h2>
                        </div>
                    ) : (
                        filteredResources.monitored_resources.map((resource, index) => (
                            <CardItem key={index} className="Card-Transact">
                                <CardBody className="pt-0 pl-2 pr-2 pb-1">
                                    <Row className="align-items-center">
                                        <Col md="2" className="padding-t-15 align-items-center justify-content-center">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div className="resource-logo-display justify-content-center">
                                                    <img
                                                        src={getStateSpecificDatadogLogo(resource.monitored_resource.master_resource_name, resource.monitored_resource.is_application_active)}
                                                        className="resource-logo"
                                                        alt="Resource Logo"
                                                    />
                                                </div>
                                                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', justifyContent: 'center' }}
                                                     onMouseEnter={() => handleMouseEnter(resource.monitored_resource.id)} onMouseLeave={handleMouseLeave}>
                                                    <h6 className="resource-name-truncate" id={`resourceName-${index}`}>
                                                        {resource.monitored_resource.name}
                                                    </h6>
                                                </div>
                                                {hoveredResource === resource.monitored_resource.id && (
                                                    <Popover placement="top" isOpen={true} target={`resourceName-${index}`}>
                                                        <PopoverBody>{resource.monitored_resource.name}</PopoverBody>
                                                    </Popover>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md="2" className="padding-t-15 align-items-start">
                                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                                <div className="mb-2 text-center">
                                                    {getDatadogName(resource.monitored_resource.master_resource_name)}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" className="padding-t-15 align-items-start">
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', marginBottom:'5px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1em', clear: 'both' }}>
                                                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {resource.monitored_resource.datadog_reference_id}
                                                    </div>
                                                    <div className="copy-cloud-id" style={{ display: 'flex', alignItems: 'center', marginLeft: '2px' }}>
                                                        <i className="bx bx-copy" style={{ cursor: 'pointer', width: '15px', height: '15px' }} onClick={() => {
                                                            copyToClipboard(resource.monitored_resource.datadog_reference_id)
                                                        }} id={`cloudId-${index}`}></i>
                                                        <UncontrolledTooltip placement="top" target={`cloudId-${index}`}>
                                                            Copy Cloud ID
                                                        </UncontrolledTooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" className="padding-t-15">
                                            <div style={{ display: 'flex', justifyContent: 'center',gap: '10px' }}>
                                                <div className="mb-2 text-center">
                                                    {getDatadogName(resource.parent_resource.master_resource_name)}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" className="padding-t-15">
                                            <div style={{ display: 'flex', justifyContent: 'center',marginLeft:'20px'}}>
                                                <div className="text-center mb-2">
                                                    {formatResourceMetadata(resource.monitored_resource.resource_metadata)}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" className="padding-t-15">
                                            <div className='text-success' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}
                                                 id={`tooltip-register-button-${index}`}>
                                                <button
                                                    className="btn btn-primary waves-effect waves-light"
                                                    onClick={() => {
                                                    handleDeployRegisterAPIEndpoint(resource.monitored_resource.id)
                                                    }}
                                                    disabled={
                                                        (primaryNotifChannel === 'Email' || primaryNotifChannel === 'OpsGenie') ?
                                                            (resource.parent_resource.application_service_id === null) :
                                                            (resource.parent_resource.pagerduty_service_id === null)
                                                    }
                                                > Register API Endpoint
                                                </button>
                                                {
                                                    ((primaryNotifChannel === 'Email' || primaryNotifChannel === 'OpsGenie') ?
                                                        (resource.parent_resource.application_service_id === null) :
                                                        (resource.parent_resource.pagerduty_service_id === null)) &&
                                                    <UncontrolledTooltip placement="top" target={`tooltip-register-button-${index}`}>
                                                        Parent Resource must be mapped to a service
                                                    </UncontrolledTooltip>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </CardItem>
                        ))
                    )}
                </div>
            </div>
            <Loader
                isOpen={isLoading2}
                lottieJson={delpoyAlertsLottie}
                messageHeader="Registering API Endpoint"
                message="That was easy! Hang tight while we register your api endpoint."
            />
            <Modal isOpen={showConfirmationModal} role="dialog" autoFocus={true} keyboard={false} centered backdrop="static" data-toggle="modal" toggle={() => setShowConfirmationModal(false)}>
                <div>
                    <ModalHeader className="border-bottom-2">
                        <span className="modal-header-resource">Confirm Deployment</span>
                    </ModalHeader>
                </div>
                <div className="modal-body">
                    <Row className="full-width">
                        <Col lg="12" className="mt-4">
                            <div className="text-center mb-4">
                                <div className="row justify-content-center">
                                    <div className="col-xl-10">
                                        <h4 className="text-primary">Are you sure you want to Register this API Endpoint?</h4>
                                        <h6 className="mt-4">
                                            This action cannot be undone. Please make sure you want to proceed.
                                        </h6>
                                        <Row className="full-width">
                                            <Col lg="6" className="mt-4">
                                                <Button color="secondary" onClick={() => setShowConfirmationModal(false)} className="btn w-md">
                                                    Cancel
                                                </Button>
                                            </Col>
                                            <Col lg="6" className="mt-4">
                                                <Button color="primary" onClick={() => {
                                                    confirmRegisterAPIEndpoint();
                                                    startLoading2();
                                                }} className="btn w-md">
                                                    Confirm
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal>
            <h6 style={{ textAlign: 'right', marginTop: '5px' }}>Showing {resourceCount} of {total_resources} Results</h6>
        </React.Fragment>
    );
};

DatadogApiEndpoints.propTypes = {};

export default DatadogApiEndpoints;
